import { render, staticRenderFns } from "./ParameterManager.vue?vue&type=template&id=ca4a073a&scoped=true&"
import script from "./ParameterManager.script.js?vue&type=script&lang=js&"
export * from "./ParameterManager.script.js?vue&type=script&lang=js&"
import style0 from "./ParameterManager.scss?vue&type=style&index=0&id=ca4a073a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4a073a",
  null
  
)

export default component.exports